module.exports = __webpack_public_path__ + "static/manta-tail.c0115327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manta-tail.png
// module id = 671
// module chunks = 72138227098318